// extracted by mini-css-extract-plugin
module.exports = {"container":"Logs_container__3vZra","filters":"Logs_filters__3ksiN"};